export var USER = "user";
export var ADMIN = "admin";
export var ALL_PEOPLE = "all";
export var DEACTIVATED_PEOPLE = "deactivated";
export var FILTER_OPTIONS_NO_DEACTIVATED = [
    { label: "admin.constants.filter.activePeople.label", value: USER },
    { label: "admin.constants.filter.adminOnly.label", value: ADMIN }
];
export var FILTER_OPTIONS = FILTER_OPTIONS_NO_DEACTIVATED.concat([
    { label: "admin.constants.filter.deactivatedPeople.label", value: DEACTIVATED_PEOPLE },
    { label: "admin.constants.filter.allPeople.label", value: ALL_PEOPLE }
]);
